import { useStaticQuery, graphql } from "gatsby"

export const useExhibitionsImages = () => {
  const data = useStaticQuery(graphql`
    query {
      _001_bottom: file(
        relativePath: { eq: "img/exhibition/bottom001-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      _002_bottom: file(
        relativePath: { eq: "img/exhibition/bottom002-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      _001_small: file(
        relativePath: { eq: "img/exhibition/small001-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 690, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _002_small: file(
        relativePath: { eq: "img/exhibition/small002-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 690, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _003_small: file(
        relativePath: { eq: "img/exhibition/small003-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 565, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return data
}
